import { useNavigate } from "react-router-dom";
import '../../Pages/Pricing/Pricing.css'
import { usePageSeo } from "../../Hooks/usePageSeo";

const PageWide = (props: any) => {
    const cssClass = "Page PageWide " + props.className;

    usePageSeo(props);

    return <div className={cssClass}>
        {props.children}
    </div>
};

export default PageWide;